"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NocoModule () {
        return NocoModule;
    },
    get nocoModuleMetadata () {
        return nocoModuleMetadata;
    }
});
const _common = require("@nestjs/common");
const _platformexpress = require("@nestjs/platform-express");
const _multer = /*#__PURE__*/ _interop_require_default(require("multer"));
const _notfoundhandlermodule = require("./not-found-handler.module");
const _eventhandlerservice = require("~/services/meta-dependency/event-handler.service");
const _viewsv3service = require("~/services/v3/views-v3.service");
const _eventemittermodule = require("~/modules/event-emitter/event-emitter.module");
const _jobsmodule = require("~/modules/jobs/jobs.module");
const _socketgateway = require("~/gateways/socket.gateway");
const _globalguard = require("~/guards/global/global.guard");
const _initmetaserviceprovider = require("~/providers/init-meta-service.provider");
const _jwtstrategyprovider = require("~/providers/jwt-strategy.provider");
const _apphookslistenerservice = require("~/services/app-hooks-listener.service");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _hookhandlerservice = require("~/services/hook-handler.service");
const _mailservice = require("~/services/mail/mail.service");
const _telemetryservice = require("~/services/telemetry.service");
const _jwtstrategy = require("~/strategies/jwt.strategy");
const _userscontroller = require("~/controllers/users/users.controller");
const _usersservice = require("~/services/users/users.service");
const _constants = require("~/constants");
const _apidocscontroller = require("~/controllers/api-docs/api-docs.controller");
const _apitokenscontroller = require("~/controllers/api-tokens.controller");
const _attachmentssecurecontroller = require("~/controllers/attachments-secure.controller");
const _attachmentscontroller = require("~/controllers/attachments.controller");
const _baseuserscontroller = require("~/controllers/base-users.controller");
const _basescontroller = require("~/controllers/bases.controller");
const _cachescontroller = require("~/controllers/caches.controller");
const _calendarscontroller = require("~/controllers/calendars.controller");
const _columnscontroller = require("~/controllers/columns.controller");
const _commandpalettecontroller = require("~/controllers/command-palette.controller");
const _commentscontroller = require("~/controllers/comments.controller");
const _extensionscontroller = require("~/controllers/extensions.controller");
const _filterscontroller = require("~/controllers/filters.controller");
const _formcolumnscontroller = require("~/controllers/form-columns.controller");
const _formscontroller = require("~/controllers/forms.controller");
const _galleriescontroller = require("~/controllers/galleries.controller");
const _gridcolumnscontroller = require("~/controllers/grid-columns.controller");
const _gridscontroller = require("~/controllers/grids.controller");
const _hookscontroller = require("~/controllers/hooks.controller");
const _jobsmetacontroller = require("~/controllers/jobs-meta.controller");
const _kanbanscontroller = require("~/controllers/kanbans.controller");
const _mapscontroller = require("~/controllers/maps.controller");
const _modelvisibilitiescontroller = require("~/controllers/model-visibilities.controller");
const _notificationscontroller = require("~/controllers/notifications.controller");
const _orglcensecontroller = require("~/controllers/org-lcense.controller");
const _orgtokenscontroller = require("~/controllers/org-tokens.controller");
const _orguserscontroller = require("~/controllers/org-users.controller");
const _pluginscontroller = require("~/controllers/plugins.controller");
const _publicmetascontroller = require("~/controllers/public-metas.controller");
const _sharedbasescontroller = require("~/controllers/shared-bases.controller");
const _sortscontroller = require("~/controllers/sorts.controller");
const _sourcescontroller = require("~/controllers/sources.controller");
const _synccontroller = require("~/controllers/sync.controller");
const _tablescontroller = require("~/controllers/tables.controller");
const _utilscontroller = require("~/controllers/utils.controller");
const _viewcolumnscontroller = require("~/controllers/view-columns.controller");
const _viewscontroller = require("~/controllers/views.controller");
const _metaservice = require("~/meta/meta.service");
const _apidocsservice = require("~/services/api-docs/api-docs.service");
const _apitokensservice = require("~/services/api-tokens.service");
const _attachmentsservice = require("~/services/attachments.service");
const _auditsservice = require("~/services/audits.service");
const _baseusersservice = require("~/services/base-users/base-users.service");
const _basesservice = require("~/services/bases.service");
const _cachesservice = require("~/services/caches.service");
const _calendarsservice = require("~/services/calendars.service");
const _columnsservice = require("~/services/columns.service");
const _commandpaletteservice = require("~/services/command-palette.service");
const _duplicatedetectionservice = require("~/services/duplicate-detection.service");
const _commentsservice = require("~/services/comments.service");
const _extensionsservice = require("~/services/extensions.service");
const _filtersservice = require("~/services/filters.service");
const _formcolumnsservice = require("~/services/form-columns.service");
const _formsservice = require("~/services/forms.service");
const _galleriesservice = require("~/services/galleries.service");
const _gridcolumnsservice = require("~/services/grid-columns.service");
const _gridsservice = require("~/services/grids.service");
const _hooksservice = require("~/services/hooks.service");
const _jobsmetaservice = require("~/services/jobs-meta.service");
const _kanbansservice = require("~/services/kanbans.service");
const _mapsservice = require("~/services/maps.service");
const _metadiffsservice = require("~/services/meta-diffs.service");
const _modelvisibilitiesservice = require("~/services/model-visibilities.service");
const _nocojobsservice = require("~/services/noco-jobs.service");
const _notificationsservice = require("~/services/notifications/notifications.service");
const _orglcenseservice = require("~/services/org-lcense.service");
const _orgtokenseeservice = require("~/services/org-tokens-ee.service");
const _orgtokensservice = require("~/services/org-tokens.service");
const _orgusersservice = require("~/services/org-users.service");
const _pluginsservice = require("~/services/plugins.service");
const _publicmetasservice = require("~/services/public-metas.service");
const _sharedbasesservice = require("~/services/shared-bases.service");
const _sortsservice = require("~/services/sorts.service");
const _sourcesservice = require("~/services/sources.service");
const _syncservice = require("~/services/sync.service");
const _tablesservice = require("~/services/tables.service");
const _utilsservice = require("~/services/utils.service");
const _viewcolumnsservice = require("~/services/view-columns.service");
const _viewsservice = require("~/services/views.service");
const _mcpservice = require("~/services/mcp.service");
const _mcpservice1 = require("~/mcp/mcp.service");
const _mcpcontroller = require("~/mcp/mcp.controller");
const _internalcontroller = require("~/controllers/internal.controller");
const _viewrowcolorv3service = require("~/services/v3/view-row-color-v3.service");
const _dependencyservice = require("~/services/dependency.service");
const _bulkdataaliascontroller = require("~/controllers/bulk-data-alias.controller");
const _calendarsdatascontroller = require("~/controllers/calendars-datas.controller");
const _dataaliasnestedcontroller = require("~/controllers/data-alias-nested.controller");
const _dataaliascontroller = require("~/controllers/data-alias.controller");
const _datatablecontroller = require("~/controllers/data-table.controller");
const _datascontroller = require("~/controllers/datas.controller");
const _integrationscontroller = require("~/controllers/integrations.controller");
const _olddatascontroller = require("~/controllers/old-datas/old-datas.controller");
const _olddatasservice = require("~/controllers/old-datas/old-datas.service");
const _publicdatascontroller = require("~/controllers/public-datas.controller");
const _basesv3controller = require("~/controllers/v3/bases-v3.controller");
const _columnsv3controller = require("~/controllers/v3/columns-v3.controller");
const _datav3controller = require("~/controllers/v3/data-v3.controller");
const _filtersv3controller = require("~/controllers/v3/filters-v3.controller");
const _sortsv3controller = require("~/controllers/v3/sorts-v3.controller");
const _tablesv3controller = require("~/controllers/v3/tables-v3.controller");
const _bulkdataaliasservice = require("~/services/bulk-data-alias.service");
const _calendardatasservice = require("~/services/calendar-datas.service");
const _basemembersv3service = require("~/services/v3/base-members-v3.service");
const _viewrowcolorservice = require("~/services/view-row-color.service");
const _dataaliasnestedservice = require("~/services/data-alias-nested.service");
const _datatableservice = require("~/services/data-table.service");
const _datasservice = require("~/services/datas.service");
const _formulacolumntypechangerservice = require("~/services/formula-column-type-changer.service");
const _integrationsservice = require("~/services/integrations.service");
const _publicdatasexportservice = require("~/services/public-datas-export.service");
const _publicdatasservice = require("~/services/public-datas.service");
const _basesv3service = require("~/services/v3/bases-v3.service");
const _columnsv3service = require("~/services/v3/columns-v3.service");
const _datav3service = require("~/services/v3/data-v3.service");
const _filtersv3service = require("~/services/v3/filters-v3.service");
const _sortsv3service = require("~/services/v3/sorts-v3.service");
const _tablesv3service = require("~/services/v3/tables-v3.service");
const _viewrowcolorcontroller = require("~/controllers/view-row-color.controller");
const _attachmenturluploadhandler = require("~/services/emit-handler/attachment-url-upload.handler");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _dataattachmentv3service = require("~/services/v3/data-attachment-v3.service");
const _oauthmodule = require("~/modules/oauth/oauth.module");
const _provider = require("~/controllers/internal/provider");
const _metadependencyprovider = require("~/services/meta-dependency/meta-dependency.provider");
const _telemetryhandlerservice = require("~/services/telemetry-handler.service");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
const nocoModuleMetadata = {
    imports: [
        _eventemittermodule.EventEmitterModule,
        _jobsmodule.JobsModule,
        _platformexpress.MulterModule.register({
            storage: _multer.default.diskStorage({}),
            limits: {
                fieldSize: _constants.NC_NON_ATTACHMENT_FIELD_SIZE,
                fileSize: _constants.NC_ATTACHMENT_FIELD_SIZE,
                files: _constants.NC_MAX_ATTACHMENTS_ALLOWED
            }
        }),
        _oauthmodule.OAuthModule,
        // put it at the bottom most since it's route not found handling
        // resorting to import to be resolved the last
        _notfoundhandlermodule.NotFoundHandlerModule
    ],
    controllers: [
        ...process.env.NC_WORKER_CONTAINER !== 'true' ? [
            /* Users */ _userscontroller.UsersController,
            /* Metas */ _apidocscontroller.ApiDocsController,
            _apitokenscontroller.ApiTokensController,
            ...process.env.NC_SECURE_ATTACHMENTS === 'true' ? [
                _attachmentssecurecontroller.AttachmentsSecureController
            ] : [
                _attachmentscontroller.AttachmentsController
            ],
            _sourcescontroller.SourcesController,
            _cachescontroller.CachesController,
            _calendarscontroller.CalendarsController,
            _columnscontroller.ColumnsController,
            _commentscontroller.CommentsController,
            _filterscontroller.FiltersController,
            _formcolumnscontroller.FormColumnsController,
            _formscontroller.FormsController,
            _galleriescontroller.GalleriesController,
            _gridcolumnscontroller.GridColumnsController,
            _gridscontroller.GridsController,
            _hookscontroller.HooksController,
            _kanbanscontroller.KanbansController,
            _mapscontroller.MapsController,
            _modelvisibilitiescontroller.ModelVisibilitiesController,
            _orglcensecontroller.OrgLcenseController,
            _orgtokenscontroller.OrgTokensController,
            _orguserscontroller.OrgUsersController,
            _pluginscontroller.PluginsController,
            _baseuserscontroller.BaseUsersController,
            _basescontroller.BasesController,
            _publicmetascontroller.PublicMetasController,
            _viewscontroller.ViewsController,
            _viewcolumnscontroller.ViewColumnsController,
            _utilscontroller.UtilsController,
            _tablescontroller.TablesController,
            _synccontroller.SyncController,
            _sortscontroller.SortsController,
            _sharedbasescontroller.SharedBasesController,
            _notificationscontroller.NotificationsController,
            _commandpalettecontroller.CommandPaletteController,
            _extensionscontroller.ExtensionsController,
            _jobsmetacontroller.JobsMetaController,
            _integrationscontroller.IntegrationsController,
            _internalcontroller.InternalController,
            // MCP
            _mcpcontroller.McpController,
            _viewrowcolorcontroller.ViewRowColorController,
            /* V3 APIs */ _basesv3controller.BasesV3Controller,
            _tablesv3controller.TablesV3Controller,
            _columnsv3controller.ColumnsV3Controller,
            _sortsv3controller.SortsV3Controller,
            _filtersv3controller.FiltersV3Controller,
            /* Datas */ _datatablecontroller.DataTableController,
            _datascontroller.DatasController,
            _calendarsdatascontroller.CalendarDatasController,
            _bulkdataaliascontroller.BulkDataAliasController,
            _dataaliascontroller.DataAliasController,
            _dataaliasnestedcontroller.DataAliasNestedController,
            _olddatascontroller.OldDatasController,
            _publicdatascontroller.PublicDatasController,
            _datav3controller.Datav3Controller
        ] : []
    ],
    providers: [
        /* Generic */ _initmetaserviceprovider.InitMetaServiceProvider,
        _jwtstrategyprovider.JwtStrategyProvider,
        _globalguard.GlobalGuard,
        _socketgateway.SocketGateway,
        _apphooksservice.AppHooksService,
        _apphookslistenerservice.AppHooksListenerService,
        _telemetryservice.TelemetryService,
        _telemetryhandlerservice.TelemetryHandlerService,
        _hookhandlerservice.HookHandlerService,
        _mailservice.MailService,
        _extractidsmiddleware.AclMiddleware,
        /* Users */ _usersservice.UsersService,
        /* Metas */ _apidocsservice.ApiDocsService,
        _apitokensservice.ApiTokensService,
        _attachmentsservice.AttachmentsService,
        _auditsservice.AuditsService,
        _sourcesservice.SourcesService,
        _cachesservice.CachesService,
        _calendarsservice.CalendarsService,
        _columnsservice.ColumnsService,
        _duplicatedetectionservice.DuplicateDetectionService,
        _commentsservice.CommentsService,
        _filtersservice.FiltersService,
        _formcolumnsservice.FormColumnsService,
        _formsservice.FormsService,
        _galleriesservice.GalleriesService,
        _gridcolumnsservice.GridColumnsService,
        _gridsservice.GridsService,
        _hooksservice.HooksService,
        _kanbansservice.KanbansService,
        _mapsservice.MapsService,
        _metadiffsservice.MetaDiffsService,
        _modelvisibilitiesservice.ModelVisibilitiesService,
        _orglcenseservice.OrgLcenseService,
        _orgtokenseeservice.OrgTokensEeService,
        _orgtokensservice.OrgTokensService,
        _orgusersservice.OrgUsersService,
        _pluginsservice.PluginsService,
        _baseusersservice.BaseUsersService,
        _basemembersv3service.BaseMembersV3Service,
        _basesservice.BasesService,
        _publicmetasservice.PublicMetasService,
        _viewsservice.ViewsService,
        _viewcolumnsservice.ViewColumnsService,
        _utilsservice.UtilsService,
        _tablesservice.TablesService,
        _syncservice.SyncService,
        _sortsservice.SortsService,
        _sharedbasesservice.SharedBasesService,
        _notificationsservice.NotificationsService,
        _commandpaletteservice.CommandPaletteService,
        _extensionsservice.ExtensionsService,
        _jobsmetaservice.JobsMetaService,
        _integrationsservice.IntegrationsService,
        _basesv3service.BasesV3Service,
        _tablesv3service.TablesV3Service,
        _columnsv3service.ColumnsV3Service,
        _sortsv3service.SortsV3Service,
        _filtersv3service.FiltersV3Service,
        _nocojobsservice.NocoJobsService,
        _mcpservice.McpTokenService,
        _mcpservice1.McpService,
        _viewrowcolorservice.ViewRowColorService,
        _viewrowcolorv3service.ViewRowColorV3Service,
        _viewsv3service.ViewsV3Service,
        _dependencyservice.DependencyService,
        /* Datas */ _datatableservice.DataTableService,
        _datasservice.DatasService,
        _bulkdataaliasservice.BulkDataAliasService,
        _dataaliasnestedservice.DataAliasNestedService,
        _calendardatasservice.CalendarDatasService,
        _olddatasservice.OldDatasService,
        _publicdatasservice.PublicDatasService,
        _publicdatasexportservice.PublicDatasExportService,
        _datav3service.DataV3Service,
        {
            provide: 'IViewsV3Service',
            useClass: _viewsv3service.ViewsV3Service
        },
        {
            provide: 'IColumnsV3Service',
            useClass: _columnsv3service.ColumnsV3Service
        },
        _dataattachmentv3service.DataAttachmentV3Service,
        // use custom provider to avoid circular dependency
        {
            provide: 'FormulaColumnTypeChanger',
            useClass: _formulacolumntypechangerservice.FormulaColumnTypeChanger
        },
        /* emit handlers */ _attachmenturluploadhandler.AttachmentUrlUploadHandler,
        ..._provider.InternalApiModules,
        _provider.InternalApiModuleProvider,
        /* Dependency handler */ _eventhandlerservice.MetaDependencyEventHandler,
        ..._metadependencyprovider.MetaDependencyServices,
        _metadependencyprovider.MetaDependencyModuleProvider
    ],
    exports: [
        /* Generic */ _apphooksservice.AppHooksService,
        _telemetryservice.TelemetryService,
        _hookhandlerservice.HookHandlerService,
        _jwtstrategy.JwtStrategy,
        /* Users */ _usersservice.UsersService,
        /* Metas */ _metaservice.MetaService,
        _tablesservice.TablesService,
        _columnsservice.ColumnsService,
        _duplicatedetectionservice.DuplicateDetectionService,
        _filtersservice.FiltersService,
        _sortsservice.SortsService,
        _viewsservice.ViewsService,
        _viewcolumnsservice.ViewColumnsService,
        _gridsservice.GridsService,
        _calendarsservice.CalendarsService,
        _gridcolumnsservice.GridColumnsService,
        _formsservice.FormsService,
        _formcolumnsservice.FormColumnsService,
        _galleriesservice.GalleriesService,
        _kanbansservice.KanbansService,
        _basesservice.BasesService,
        _attachmentsservice.AttachmentsService,
        _baseusersservice.BaseUsersService,
        _hooksservice.HooksService,
        _metadiffsservice.MetaDiffsService,
        _sourcesservice.SourcesService,
        _utilsservice.UtilsService,
        _integrationsservice.IntegrationsService,
        _nocojobsservice.NocoJobsService,
        _viewrowcolorservice.ViewRowColorService,
        _viewrowcolorv3service.ViewRowColorV3Service,
        _dependencyservice.DependencyService,
        _mailservice.MailService,
        /* Datas */ _datasservice.DatasService,
        _bulkdataaliasservice.BulkDataAliasService,
        _datatableservice.DataTableService,
        _datav3service.DataV3Service,
        _dataattachmentv3service.DataAttachmentV3Service,
        'IViewsV3Service',
        _attachmenturluploadhandler.AttachmentUrlUploadHandler,
        ..._provider.InternalApiModules,
        _eventhandlerservice.MetaDependencyEventHandler,
        ..._metadependencyprovider.MetaDependencyServices
    ]
};
let NocoModule = class NocoModule {
};
NocoModule = _ts_decorate([
    (0, _common.Module)(nocoModuleMetadata)
], NocoModule);
